var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-xl-nowrap flex-lg-wrap align-items-center"},[_c('b-badge',{attrs:{"variant":_vm.stateColor}},[_vm._v(_vm._s(_vm.stateString))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }